// Create new file: framework/common/schemas/collections/newsletterSubscriptions.js
import { z } from "zod";

const NewsletterSubscriptionSchema = z.object({
    _id: z.string().optional(),
    appName: z.string().describe("The name of the application from which the subscription was made."),
    name: z.string().optional().nullable(),
    email: z.string().email(),
    phoneNumber: z.string().optional().nullable(),
    whatsappConsent: z.boolean().default(false),
    status: z.enum(['active', 'unsubscribed']).default('active'),
    createdAt: z.date().optional(),
});

export default NewsletterSubscriptionSchema;